// This version is baked in upon building the react app

export const RADAR_VERSION = process.env.REACT_APP_RELEASE_TAG || "N/A";
